<template>
    <div>
        <BRow>
            <BCol>
                <div class="demo-inline-spacing text-center">
                    <div>{{ $t('Page(ReceivedRequest):Component(Text):is-purchased-from-supplier') }}</div>
                    <BFormRadio
                        name="workflow-is-purchased"
                        :checked="type"
                        :value="purchasedType"
                        @change="$emit('change-type', $event)"
                    >
                        {{ $t('Component(Choice):yes') }}
                    </BFormRadio>
                    <BFormRadio
                        name="workflow-is-purchased"
                        :checked="type"
                        :value="ownType"
                        @change="$emit('change-type', $event)"
                    >
                        {{ $t('Component(Choice):no') }}
                    </BFormRadio>
                    <InstructionInfoButton
                        class="pl-1"
                        :instruction="$t('Page(ReceivedRequest):Component(IButton):received-request-purchase-from-supplier-instruction')"
                    />
                </div>
            </BCol>
        </BRow>
        <Transition name="fade">
            <BRow v-if="isPurchased" class="mt-2">
                <BCol>
                    <SupplierSelector
                        border-variant="default"
                        :selected="suppliers"
                        @change="(ids, items) => $emit('change-suppliers', ids, items)"
                    >
                        <template #under-heading>
                            <InstructionText class="m-1 simple-flow-instruction">
                                {{ $t('Page(ReceivedRequest):Component(Instruction):supplier-information') }}
                            </InstructionText>
                        </template>
                    </SupplierSelector>
                </BCol>
            </BRow>
        </Transition>
    </div>
</template>

<script>
import { BCol, BFormRadio, BRow } from 'bootstrap-vue'
import { SupplierSelector } from '@core/components/supply-chain'
import InstructionInfoButton from '@core/components/common/instructions/InstructionInfoButton.vue'
import InstructionText from '@core/components/common/instructions/InstructionText.vue'

export default {
    name: 'WorkflowProductSupplySection',
    components: {
        BCol,
        BFormRadio,
        BRow,
        InstructionInfoButton,
        InstructionText,
        SupplierSelector,
    },
    props: {
        type: { type: String, required: true },
        ownType: { type: String, required: true },
        purchasedType: { type: String, required: true },
        isPurchased: { type: Boolean, required: true },
        suppliers: { type: Array, default: () => [] },
    },
}
</script>
